import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import Api from "../core/api/api";
export const uploadDocument = createAsyncThunk(
  "ocr/uploadDocument",
  async (formdata: any) => {
    const response = await axiosInstance.post(
      Api.upload_document_ocr,
      formdata
    );
    return response.data;
  }
);

export const getDocument = createAsyncThunk(
  "ocr/getDocument",
  async (updateObj: any) => {
    const response = await axiosInstance.get(Api.upload_document_ocr + updateObj);
    return response.data;
  }
);

export const getKPIDetails = createAsyncThunk(
  "ocr/getKPIDetails",
  async () => {
    const response = await axiosInstance.get(Api.upload_document_ocr_kpi);
    return response.data;
  }
);

export const getDocumentDetails = createAsyncThunk(
  "ocr/getDocumentDetails",
  async (updateObj: any) => {
    const response = await axiosInstance.get(Api.document_details + updateObj);
    return response.data;
  }
);

export const postChatOcrApi = createAsyncThunk(
  "ocr/postChatOcrApi",
  async (updateObj: any) => {
  return await axiosInstance.put(Api.postChatOcrMessage, updateObj);
  }
  );

export const deleteDocument = createAsyncThunk(
  "ocr/deleteDocument",
  async (id: any) => {
    const response = await axiosInstance.delete(
      Api.upload_document_ocr +
      '?document_id=' + id
    );
    return response;
  }
);
